<template>
  <svg
    :style="{
      position: 'fixed',
      width: svgWidth,
      height: svgHeight,
      'pointer-events': 'none',
      zIndex: 2,
      top: mouseY,
      left: svgLeft,
    }"
    id="svg-safe-area">
    <path
      class="path1"
      pointer-events="none"
      width="100%"
      height="100%"
      :d="`M 0,0 L ${svgWidth},0 L ${svgWidth},${svgHeight} L 0,${svgHeight} z`"
    />
    <path
      class="path2"
      pointer-events="auto"
      :d="`M ${mouseX - svgLeft},5
          L ${0},${svgHeight}
          L ${svgWidth},${svgHeight} z`"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'SafeArea',

  props: {
    mouseX: Number,
    mouseY: Number,
    svgWidth: {
      type: Number,
      default: 844
    },
    left: Number,
    height: {
      type: Number,
      default: 56
    }
  },

  data () {
    return {
      // svgWidth: 844
    }
  },

  computed: {
    svgHeight () {
      return this.height - this.mouseY
    },
    svgLeft () {
      if (!isNaN(this.left)) return this.left
      return (window.innerWidth - this.svgWidth) / 2
    }
  }
}
</script>

<style lang="stylus" scoped>
svg {
  .path1 {
    fill: transparent;
    // fill: rgba(187,39,38,0.05);
  }
  .path2 {
    fill: transparent;
    // fill: rgba(114,140,89,0.3);
  }
}
</style>
